/** 本地新建菜单数据格式 */
/** [{ // 根目录
  id: 1000,
  parentId: -1,
  code: 'template' // 编码
  icon: 'yingxiaozhongxinicon',
  name: '本地模板',
  menuUrl: '/template/index',
  routerIndex: 1000,
  'visible': true // 是否可见
},
 { // 子级
  id: 1001,
  parentId: 1000,
  code: 'templateList' // 编码
  name: '模板列表',
  menuUrl: '/template/list',
  routerIndex: 1,
  visible: true,
},
 { // 非菜单的路由
  id: 10011,
  parentId: 1001,
  code: 'addTemplate'
  name: '模板列表',
  menuUrl: '/template/add',
  visible': false
}] **/

export default [{
  'id': 1,
  'parentId': -1,
  'name': '概览',
  'enName': 'Overview',
  'code': 'Overview',
  'menuUrl': '/overview',
  'menuPath': '',
  'routerIndex': 1,
  'visible': true,
  'icon': 'overview'
}, {
  'id': 11,
  'parentId': 1,
  'name': '今日概览',
  'enName': 'Today Overview',
  'code': 'todayOverview',
  'menuUrl': '/overview/dashboard',
  'menuPath': '/dashboard/index',
  'routerIndex': 1,
  'visible': true,
  'icon': ''
}, {
  'id': 12,
  'parentId': 1,
  'name': '我的概览',
  'enName': 'Mine Overview',
  'code': 'mineOverview',
  'menuUrl': '/overview/mine',
  'menuPath': '/dataOverview/mine/list',
  'routerIndex': 2,
  'visible': true,
  'icon': ''
}, {
  'id': 13,
  'parentId': 1,
  'name': '分享给我的概览',
  'enName': 'Share Overview',
  'code': 'shareOverview',
  'menuUrl': '/overview/share',
  'menuPath': '/dataOverview/share/list',
  'routerIndex': 3,
  'visible': false,
  'icon': ''
}, {
  'id': 14,
  'parentId': 1,
  'name': '概览详情',
  'enName': 'Overview Detail',
  'code': 'overviewDetail',
  'menuUrl': '/overview/detail',
  'menuPath': '/dataOverview/template',
  'routerIndex': 4,
  'visible': false,
  'icon': ''
}, {
  'id': 15,
  'parentId': 1,
  'name': '书签列表',
  'enName': 'Bookmark List',
  'code': 'bookmarkList',
  'menuUrl': '/overview/bookMark',
  'menuPath': '/bookMark/list',
  'routerIndex': 5,
  'visible': true,
  'icon': ''
}, {
  'id': 16,
  'parentId': 1,
  'name': '预警管理',
  'enName': 'Warning Management',
  'code': 'warningManagement',
  'menuUrl': '/overview/warning_manage/list',
  'menuPath': '/warning_manage/list',
  'routerIndex': 6,
  'visible': false,
  'icon': ''
}, {
  'id': 2,
  'parentId': -1,
  'name': '分析',
  'enName': 'Analysis',
  'code': 'analysis',
  'menuUrl': '/analyse',
  'menuPath': '',
  'routerIndex': 2,
  'visible': true,
  'icon': 'user_analyse'
}, {
  'id': 21,
  'parentId': 2,
  'name': '整体分析',
  'enName': 'Overall Analysis',
  'code': 'overallAnalysis',
  'menuUrl': '/analyse/overall',
  'menuPath': '/analyse/overall/form',
  'routerIndex': 1,
  'visible': true,
  'icon': ''
}, {
  'id': 22,
  'parentId': 2,
  'name': '事件分析',
  'enName': 'Event Analysis',
  'code': 'eventAnalysis',
  'menuUrl': '/analyse/event',
  'menuPath': '/analyse/event/form',
  'routerIndex': 2,
  'visible': true,
  'icon': ''
}, {
  'id': 23,
  'parentId': 2,
  'name': '页面分析',
  'enName': 'Page Analysis',
  'code': 'pageAnalysis',
  'menuUrl': '/analyse/page',
  'menuPath': '/analyse/page/form',
  'routerIndex': 3,
  'visible': true,
  'icon': ''
}, {
  'id': 24,
  'parentId': 2,
  'name': '漏斗分析',
  'enName': 'Funnel Analysis',
  'code': 'funnelAnalysis',
  'menuUrl': '/analyse/funnel',
  'menuPath': '/analyse/funnel/form',
  'routerIndex': 4,
  'visible': true,
  'icon': ''
}, {
  'id': 25,
  'parentId': 2,
  'name': '留存分析',
  'enName': 'Retained Analysis',
  'code': 'retainedAnalysis',
  'menuUrl': '/analyse/retained',
  'menuPath': '/analyse/retained/form',
  'routerIndex': 5,
  'visible': true,
  'icon': ''
}, {
  'id': 26,
  'parentId': 2,
  'name': '用户路径',
  'enName': 'User Path',
  'code': 'userPath',
  'menuUrl': '/analyse/path',
  'menuPath': '/analyse/path/form',
  'routerIndex': 6,
  'visible': true,
  'icon': ''
}, {
  'id': 27,
  'parentId': 2,
  'name': '分布分析',
  'enName': 'Distribution Analysis',
  'code': 'distributionAnalysis',
  'menuUrl': '/analyse/distribution',
  'menuPath': '/analyse/distribution/form',
  'routerIndex': 7,
  'visible': true,
  'icon': ''
}, {
  'id': 28,
  'parentId': 2,
  'name': '归因分析',
  'enName': 'Attribution Analysis',
  'code': 'attributionAnalysis',
  'menuUrl': '/analyse/attribution',
  'menuPath': '/analyse/attribution/form',
  'routerIndex': 8,
  'visible': true,
  'icon': ''
}, {
  'id': 29,
  'parentId': 2,
  'name': '渠道分析',
  'enName': 'Channel Analysis',
  'code': 'channelAnalysis',
  'menuUrl': '/analyse/channel',
  'menuPath': '/analyse/channel/form',
  'routerIndex': 9,
  'visible': true,
  'icon': ''
}, {
  'id': 210,
  'parentId': 2,
  'name': '间隔分析',
  'enName': 'Interval Analysis',
  'code': 'intervalAnalysis',
  'menuUrl': '/analyse/interval',
  'menuPath': '/analyse/interval/form',
  'routerIndex': 10,
  'visible': true,
  'icon': ''
}, {
  'id': 211,
  'parentId': 2,
  'name': 'Session分析',
  'enName': 'Session Analysis',
  'code': 'sessionAnalysis',
  'menuUrl': '/analyse/session',
  'menuPath': '/analyse/session/form',
  'routerIndex': 11,
  'visible': true,
  'icon': ''
}, {
  'id': 212,
  'parentId': 2,
  'name': '落地页分析',
  'enName': 'Landing Analysis',
  'code': 'landingAnalysis',
  'menuUrl': '/analyse/landing_page',
  'menuPath': '/analyse/landing/form',
  'routerIndex': 12,
  'visible': true,
  'icon': ''
}, {
  'id': 213,
  'parentId': 2,
  'name': '自定义指标',
  'enName': 'Custom Indicator',
  'code': 'customIndicator',
  'menuUrl': '/analyse/custom',
  'menuPath': '/analyse/custom/form',
  'routerIndex': 13,
  'visible': true,
  'icon': ''
}, {
  'id': 214,
  'parentId': 2,
  'name': 'LTV 分析',
  'enName': 'LTV Analysis',
  'code': 'LTVAnalysis',
  'menuUrl': '/analyse/ltv',
  'menuPath': '/analyse/ltv/form',
  'routerIndex': 14,
  'visible': true,
  'icon': ''
}, {
  'id': 214,
  'parentId': 2,
  'name': '操作指标',
  'enName': 'Operating Indicator',
  'code': 'operatingIndicator',
  'menuUrl': '/analyse/custom/indicator',
  'menuPath': '/analyse/custom/indicator',
  'routerIndex': 14,
  'visible': false,
  'icon': ''
}, {
  'id': 215,
  'parentId': 2,
  'name': '用户详情',
  'enName': 'User Detail',
  'code': 'analyseUserList',
  'menuUrl': '/analyse/userList',
  'menuPath': '/analyse/user/userList',
  'routerIndex': 15,
  'visible': false,
  'icon': ''
}, {
  'id': 3,
  'parentId': -1,
  'name': '分群',
  'enName': 'Group',
  'code': 'group',
  'menuUrl': '/group',
  'menuPath': '/group',
  'routerIndex': 3,
  'visible': true,
  'icon': 'user_group'
}, {
  'id': 31,
  'parentId': 3,
  'name': '用户分群',
  'enName': 'User Group',
  'code': 'userGroup',
  'menuUrl': '/group/user',
  'menuPath': '/group/user/groupList',
  'routerIndex': 1,
  'visible': true,
  'icon': ''
}, {
  'id': 32,
  'parentId': 3,
  'name': '行迹轨迹',
  'enName': 'Behavior Trace',
  'code': 'userBehavior',
  'menuUrl': '/group/behavior',
  'menuPath': '/group/behavior/userBehavior',
  'routerIndex': 2,
  'visible': true,
  'icon': ''
}, {
  'id': 33,
  'parentId': 3,
  'name': '用户列表',
  'enName': 'User List',
  'code': 'userrList',
  'menuUrl': '/group/user/pageUser',
  'menuPath': '/group/user/userList',
  'routerIndex': 3,
  'visible': false,
  'icon': ''
}, {
  'id': 4,
  'parentId': -1,
  'name': '渠道',
  'enName': 'Channel',
  'code': 'channel',
  'menuUrl': '/business_channel',
  'menuPath': '/business_channel',
  'routerIndex': 4,
  'visible': true,
  'icon': 'channel'
}, {
  'id': 41,
  'parentId': 4,
  'name': '渠道活动',
  'enName': 'Channel Activity',
  'code': 'channelActivity',
  'menuUrl': '/business_channel/activity_manage/list',
  'menuPath': '/activity_manage/list',
  'routerIndex': 1,
  'visible': true,
  'icon': 'channel'
}, {
  'id': 42,
  'parentId': 4,
  'name': '渠道链接',
  'enName': 'Channel Link',
  'code': 'channelLink',
  'menuUrl': '/business_channel/channel_link/list',
  'menuPath': '/channel_link/list',
  'routerIndex': 2,
  'visible': true,
  'icon': ''
}, {
  'id': 43,
  'parentId': 4,
  'name': '推广渠道',
  'enName': 'Channel Promote',
  'code': 'channelPromote',
  'menuUrl': '/business_channel/list',
  'menuPath': '/business_channel/list',
  'routerIndex': 3,
  'visible': true,
  'icon': ''
}, {
  'id': 44,
  'parentId': 4,
  'name': '渠道规则',
  'enName': 'Channel Rule',
  'code': 'channelRule',
  'menuUrl': '/business_channel_rule/list',
  'menuPath': '/business_channel_rule/list',
  'routerIndex': 4,
  'visible': true,
  'icon': ''
}, {
  'id': 45,
  'parentId': 4,
  'name': '短链详情',
  'enName': 'ShortChain Detail',
  'code': 'shortChainDetail',
  'menuUrl': '/text_link/list',
  'menuPath': '/text_link/list',
  'routerIndex': 5,
  'visible': true,
  'icon': ''
}, {
  'id': 5,
  'parentId': -1,
  'name': '设置',
  'enName': 'Setting',
  'code': 'setting',
  'menuUrl': '/settings',
  'menuPath': '/settings',
  'routerIndex': 5,
  'visible': true,
  'icon': 'setting'
}, {
  'id': 51,
  'parentId': 5,
  'name': '项目列表',
  'enName': 'Project List',
  'code': 'projectList',
  'menuUrl': '/settings/project/list',
  'menuPath': '/settings/project',
  'routerIndex': 1,
  'visible': true,
  'icon': ''
}, {
  'id': 52,
  'parentId': 5,
  'name': '应用列表',
  'enName': 'Application List',
  'code': 'appList',
  'menuUrl': '/settings/application/list',
  'menuPath': '/settings/application',
  'routerIndex': 2,
  'visible': true,
  'icon': ''
}, {
  'id': 53,
  'parentId': 5,
  'name': '人员列表',
  'enName': 'Person List',
  'code': 'personList',
  'menuUrl': '/settings/user',
  'menuPath': '/settings/users',
  'routerIndex': 3,
  'visible': true,
  'icon': ''
}, {
  'id': 54,
  'parentId': 5,
  'name': '角色管理',
  'enName': 'Role Management',
  'code': 'roleManagement',
  'menuUrl': '/settings/role/list',
  'menuPath': '/role/list',
  'routerIndex': 4,
  'visible': true,
  'icon': ''
}, {
  'id': 55,
  'parentId': 5,
  'name': '租户信息',
  'enName': 'Tenant Information',
  'code': 'tenantInformation',
  'menuUrl': '/settings/tenant',
  'menuPath': '/settings/tenant',
  'routerIndex': 5,
  'visible': true,
  'icon': ''
}, {
  'id': 56,
  'parentId': 5,
  'name': '帐号设置',
  'enName': 'Account Setting',
  'code': 'accountSetting',
  'menuUrl': '/settings/personal',
  'menuPath': '/settings/personal',
  'routerIndex': 6,
  'visible': false,
  'icon': ''
}, {
  'id': 57,
  'parentId': 5,
  'name': '开发配置',
  'enName': 'Develop Configuration',
  'code': 'developConfiguration',
  'menuUrl': '/settings/developConfig',
  'menuPath': '/settings/develop_config',
  'routerIndex': 7,
  'visible': true,
  'icon': ''
}, {
  'id': 58,
  'parentId': 5,
  'name': '操作日志',
  'enName': 'Operation Log',
  'code': 'operationLog',
  'menuUrl': '/settings/operationLog',
  'menuPath': '/settings/operationLog/index',
  'routerIndex': 8,
  'visible': true,
  'icon': ''
}, {
  'id': 6,
  'parentId': -1,
  'name': '埋点',
  'enName': 'Buried Point',
  'code': 'buriedPoint',
  'menuUrl': '/buriedPoint',
  'menuPath': '/buriedPoint',
  'routerIndex': 6,
  'visible': true,
  'icon': 'buried_point'
}, {
  'id': 61,
  'parentId': 6,
  'name': '日志查询',
  'enName': 'Log Query',
  'code': 'aliyunLogQuery',
  'menuUrl': '/buried_point/log/aliyun',
  'menuPath': '/log/aliyun/list',
  'routerIndex': 1,
  'visible': true,
  'icon': ''
}, {
  'id': 62,
  'parentId': 6,
  'name': '日志查询',
  'enName': 'Log Query',
  'code': 'ckLogQuery',
  'menuUrl': '/buried_point/log/ck',
  'menuPath': '/log/ck/list',
  'routerIndex': 2,
  'visible': true,
  'icon': ''
}, {
  'id': 63,
  'parentId': 6,
  'name': '页面属性',
  'enName': 'Page Attribute',
  'code': 'pageAttribute',
  'menuUrl': '/buried_point/page_attribute',
  'menuPath': '/page_attribute/list',
  'routerIndex': 3,
  'visible': true,
  'icon': ''
}, {
  'id': 64,
  'parentId': 6,
  'name': '事件回收',
  'enName': 'Event Recycle',
  'code': 'eventRecycle',
  'menuUrl': '/buried_point/event_recycle',
  'menuPath': '/event_recycle/list',
  'routerIndex': 4,
  'visible': true,
  'icon': ''
}, {
  'id': 65,
  'parentId': 6,
  'name': '事件分组',
  'enName': 'Event Group',
  'code': 'eventGroup',
  'menuUrl': '/buried_point/event_group',
  'menuPath': '/event_group/list',
  'routerIndex': 5,
  'visible': true,
  'icon': ''
}, {
  'id': 66,
  'parentId': 6,
  'name': '自定事件',
  'enName': 'Custom Event',
  'code': 'customEvent',
  'menuUrl': '/buried_point/custom_event',
  'menuPath': '/custom_event/list',
  'routerIndex': 6,
  'visible': true,
  'icon': ''
}, {
  'id': 67,
  'parentId': 6,
  'name': '虚拟事件',
  'enName': 'Virtual Event',
  'code': 'virtualEvent',
  'menuUrl': '/buried_point/virtual_event',
  'menuPath': '/virtual_event/list',
  'routerIndex': 7,
  'visible': true,
  'icon': ''
}, {
  'id': 68,
  'parentId': 6,
  'name': '元事件',
  'enName': 'Meta Event',
  'code': 'metaEvent',
  'menuUrl': '/buried_point/meta_event',
  'menuPath': '/meta_event/list',
  'routerIndex': 8,
  'visible': true,
  'icon': ''
}, {
  'id': 69,
  'parentId': 6,
  'name': '元数据',
  'enName': 'Meta Data',
  'code': 'metadata',
  'menuUrl': '/buried_point/meta_data',
  'menuPath': '/meta_data/list',
  'routerIndex': 9,
  'visible': true,
  'icon': ''
}, {
  'id': 610,
  'parentId': 6,
  'name': '新增事件',
  'enName': 'New Custom Event',
  'code': 'newCustomEvent',
  'menuUrl': '/buried_point/custom_event/new',
  'menuPath': '/custom_event/new',
  'routerIndex': 10,
  'visible': false,
  'icon': ''
}, {
  'id': 611,
  'parentId': 6,
  'name': '编辑事件',
  'enName': 'Edit Custom Event',
  'code': 'editCustomEvent',
  'menuUrl': '/buried_point/custom_event/edit',
  'menuPath': '/custom_event/edit',
  'routerIndex': 11,
  'visible': false,
  'icon': ''
}, {
  'id': 612,
  'parentId': 6,
  'name': '事件详情',
  'enName': 'Custom Event Detail',
  'code': 'customEventDetail',
  'menuUrl': '/buried_point/custom_event/detail',
  'menuPath': '/custom_event/detail',
  'routerIndex': 12,
  'visible': false,
  'icon': ''
}, {
  'id': 7,
  'parentId': -1,
  'name': '系统',
  'enName': 'System',
  'code': 'system',
  'menuUrl': '/system',
  'menuPath': '/system',
  'routerIndex': 7,
  'visible': true,
  'icon': 'system'
}, {
  'id': 71,
  'parentId': 7,
  'name': '租户管理',
  'enName': 'Tenant Management',
  'code': 'tenantManagement',
  'menuUrl': '/system/tenant',
  'menuPath': '/tenant/list',
  'routerIndex': 1,
  'visible': true,
  'icon': ''
}, {
  'id': 72,
  'parentId': 7,
  'name': '权限菜单',
  'enName': 'Access Menu',
  'code': 'accessMenu',
  'menuUrl': '/system/privilege/menuList',
  'menuPath': '/privilege/menuList',
  'routerIndex': 2,
  'visible': true,
  'icon': ''
}, {
  'id': 721,
  'parentId': 7,
  'name': '系统角色管理',
  'enName': 'System Role',
  'code': 'systemRoleManage',
  'menuUrl': '/system/role',
  'menuPath': '/system/roleManage/index',
  'routerIndex': 2,
  'visible': true,
  'icon': ''
}, {
  'id': 73,
  'parentId': 7,
  'name': '用户管理',
  'enName': 'User Management',
  'code': 'userManagement',
  'menuUrl': '/system/user',
  'menuPath': '/user/list',
  'routerIndex': 3,
  'visible': true,
  'icon': ''
}, {
  'id': 74,
  'parentId': 7,
  'name': '项目管理',
  'enName': 'Project Management',
  'code': 'projectManagement',
  'menuUrl': '/system/project',
  'menuPath': '/project/list',
  'routerIndex': 4,
  'visible': true,
  'icon': ''
}, {
  'id': 75,
  'parentId': 7,
  'name': '应用管理',
  'enName': 'Application Management',
  'code': 'appManagement',
  'menuUrl': '/system/application/list',
  'menuPath': '/application/list',
  'routerIndex': 5,
  'visible': true,
  'icon': ''
}, {
  'id': 76,
  'parentId': 7,
  'name': '同步数据源',
  'enName': 'Syn Data Source',
  'code': 'mhInstanceConfigSource',
  'menuUrl': '/system/mh_instance_config/source/list',
  'menuPath': '/mh_instance_config/source/list',
  'routerIndex': 6,
  'visible': true,
  'icon': ''
}, {
  'id': 77,
  'parentId': 7,
  'name': '同步任务',
  'enName': 'Syn Task',
  'code': 'mhInstanceConfigTask',
  'menuUrl': '/system/mh_instance_config/task/list',
  'menuPath': '/mh_instance_config/task/list',
  'routerIndex': 7,
  'visible': true,
  'icon': ''
}, {
  'id': 78,
  'parentId': 7,
  'name': '系统概览',
  'enName': 'System Dashboard',
  'code': 'systemDashboard',
  'menuUrl': '/system/dashboard',
  'menuPath': '/dashboard/system/dashboard',
  'routerIndex': 8,
  'visible': true,
  'icon': ''
}, {
  'id': 99,
  'parentId': 7,
  'name': '元数据管理',
  'enName': 'Meta Data Manage',
  'code': 'Meta Data Manage',
  'menuUrl': '/system/metaDataManage',
  'menuPath': '/meta_data_manage/list',
  'routerIndex': 9,
  'visible': true,
  'icon': ''
}, {
  'id': 79,
  'parentId': 7,
  'name': '用户详情',
  'enName': 'User Detail',
  'code': 'userDetail',
  'menuUrl': '/system/user/detail',
  'menuPath': '/user/detail',
  'routerIndex': 9,
  'visible': false,
  'icon': ''
}, {
  'id': 8,
  'parentId': -1,
  'name': '用户设置',
  'enName': 'User Setting',
  'code': 'userSetting',
  'menuUrl': '/user',
  'menuPath': '/user',
  'routerIndex': 8,
  'visible': false,
  'icon': ''
}, {
  'id': 81,
  'parentId': 8,
  'name': '项目设置',
  'enName': 'Account Setting',
  'code': 'accountSetting',
  'menuUrl': '/user/accountSetting',
  'menuPath': '/settings/personal',
  'routerIndex': 1,
  'visible': false,
  'icon': ''
}]
